<template>
  <div>
    <div class="dashboard_gadget dashboard_new" v-if="authStore.isDischarger">
      <div class="gadget_left">
        <span>News</span>
        <span>{{ $t('notice') }}</span>
      </div>
      <div class="gadget_right">
        <template v-if="notiList && notiList.length > 0">
          <template v-for="data in notiList" :key="data.id">
            <div>
              <div>
                <div :class="getImportantClass(data.importance) + ' important'">
                  <template v-if="data.importance != 'BLANK'">
                    <span>{{ $t('important_ja') }}</span>
                  </template>
                </div>
                <div class="notice_update_date">
                  <span>{{ formatDate(data.date) }}</span>
                </div>
                <div class="notice_subject">
                  <span>{{ data.subject }}</span>
                </div>
              </div>
              <div>
                <span v-html="data.content" class="ellipsis" @mouseover="handleHover($event)" @click="changeEllipsis($event,'notice')"></span>
              </div>
            </div>
          </template>
        </template>
      
        <template v-else>
          <div class="flex flex-col items-center justify-center text-gray-300 text-sm mt-5">
            <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1)" fill="none" fill-rule="evenodd"><ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse><g fill-rule="nonzero" stroke="#d9d9d9"><path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path><path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path></g></g></svg>
            <span class="mt-2" >データがありません</span>
          </div>
        </template>
      </div>
      
    </div>

    <div class="dashboard_gadget dashboard_update">
      <div class="gadget_left">
        <span>Update</span>
        <span>{{ $t('update_info') }}</span>
      </div>
      <div class="gadget_right">
       <template v-if="updateReports && updateReports.length > 0">
        <template v-for="data in updateReports">
          <div>
            <div>
              <div class="update_date">
                <span>{{ data.date }}</span>
              </div>
              <div class="update_info">
                <span v-html="data.content" 
                class="ellipsis" 
                @click="changeEllipsis($event,'update')" 
                @mouseover="handleHover($event)">
                </span>
              </div>
            </div>
          </div>
        </template>
       </template>

        <template v-else>
          <div class="flex flex-col items-center justify-center text-gray-300 text-sm mt-5">
            <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1)" fill="none" fill-rule="evenodd"><ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse><g fill-rule="nonzero" stroke="#d9d9d9"><path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path><path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path></g></g></svg>
            <span class="mt-2" >データがありません</span>
          </div>
        </template>
      </div>
    </div>

    <div class="dashboard_gadget dashboard_project">
      <div class="gadget_left">
        <span>Project</span>
        <span>{{ $t('project_info') }}</span>
      </div>
      <div class="gadget_right">
        <a-table
          :columns="projColumn"
          :dataSource="dataSourceProject"
          :pagination="false"
          :scroll="{ x: '780px', y: '200px' }"
        >
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'status'">
              <span v-if="isDischarger" class="flex justify-center ml-2">
                <a-tag :class="[(PROJECT.PROJECT_STATUS_CLASS as Record<string, string>)[text], 'status-tag']">
                    {{ (PROJECT.PROJECT_STATUS_LABEL as Record<string, string>)[text] }}
                </a-tag>
               </span>
                <span v-else class="flex justify-center ml-2">
                <a-tag v-if="text !== 'CREATING_CONTRACT'" :class="[(PROJECT.PROJECT_STATUS_CLASS as Record<string, string>)[text], 'status-tag']">
                    {{ (PROJECT.PROJECT_STATUS_LABEL as Record<string, string>)[text] }}
                </a-tag>
                <a-tag v-else :class="[(PROJECT.PROJECT_STATUS_CLASS as Record<string, string>)['CREATING_CONTRACT'], 'status-tag']">{{$t('quote_approval')}}</a-tag>
                </span>
            </template>
            <template v-if="column.dataIndex === 'projectId'">
              <router-link :to="'/project-managment/detail/' + text">{{ text }}</router-link>
            </template>
            <template v-if="column.dataIndex === 'office'">
              <span>{{ text }}</span>
            </template>
            <template v-if="column.dataIndex === 'memo'">
              <a v-if="text != undefined && text.trim() != ''" @click="openMemoModal(record)">
                <img
                  src="@/assets/images/detail_icon.png"
                  alt="detail"
                  class="cursor-pointer !w-6 !h-6"
                />
              </a>
            </template>
            <template v-if="column.dataIndex === 'companyName' || column.dataIndex === 'title'">
              <div class="ant-table-cell-ellipsis">
                <a-tooltip placement="topLeft" :title="text">
                    <span>{{ text }}</span>
                </a-tooltip>
              </div>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="dashboard_gadget dashboard_inquire" v-if="authStore.isDischarger">
      <div class="gadget_left">
        <span>Inquire</span>
        <span>{{ $t('inquire') }}</span>
      </div>
      <div class="gadget_right">
        <a-table
          :columns="inquireColumn"
          :dataSource="dataSourceInquires"
          :pagination="false"
          :scroll="{ x: '980px', y: '210px' }"
        >
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'importance'">
              <span :class="getImportantClass(text) + ' important'">{{
                text != 'BLANK' ? $t('important_ja') : ''
              }}</span>
            </template>
            <template v-if="column.dataIndex === 'id'">
              <a class="hover:cursor-pointer" @click="displayContentInquire(record.id)">{{String(text).padStart(5, '0')}}</a>
            </template>
            <template v-if="column.dataIndex === 'office'">
              <span>{{ text }}</span>
            </template>
            <template v-if="column.dataIndex === 'status'">
              <span :class="getClassStatus(text) + ' status'">{{ $t(text.toLowerCase()) }}</span>
            </template>
            <template v-if="column.dataIndex === 'content'">
              <img
                src="@/assets/images/detail_icon.png"
                alt="detail"
                class="cursor-pointer !w-6 !h-6"
                @click="displayContentInquire(record.id)"
              />
            </template>
            <template v-if="column.dataIndex === 'companyName' || column.dataIndex === 'subject'">
              <div class="ant-table-cell-ellipsis">
                <a-tooltip placement="topLeft" :title="text">
                    <span>{{ text }}</span>
                </a-tooltip>
              </div>
            </template>
          </template>
        </a-table>
      </div>
    </div>
  </div>

  <a-modal v-model:visible="isMemoModalVisible" :footer="null" style="height: 500px; width: 400px" :mask-closable="false">
    <template #title>
      <div class="custom-modal-header">
        {{ $t('memo') }}
      </div>
      <hr style="margin: 0; border: 0; border-top: 1px solid #e8e8e8" />
    </template>
    <div class="memo-content">
      <span v-html="formattedMemo"></span>
    </div>  
  </a-modal>

  <InquiryDetailModal
    v-if="isInquiryModalVisible"
    v-model:visible="isInquiryModalVisible"
    :inquiryId="viewingInquiryId"
    @update="updateInquire"
  />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  getProjects,
  getInquire,
  formatDate,
  getProjColumn,
  getInquireColumn,
  changeEllipsis,
  getImportantClass,
  getNotiForHome,
  getUpdateReports,
  type Notification,
  type Report,
  handleHover
} from '@/services/modules/home';
import { useCommonStore, useAuthStore } from '@/stores';
import InquiryDetailModal from '@/views/Inquiry/InquiryDetailModal.vue';
import { storeToRefs } from 'pinia';
import { PROJECT } from '@/constants';

const { t } = useI18n();

const isMemoModalVisible = ref(false);
const isInquiryModalVisible = ref(false);
const viewingInquiryId: any = ref(null);
const commonStore = useCommonStore();
const authStore = useAuthStore();
const { selectedCompanyId } = storeToRefs(commonStore);
const dataSourceProject = ref<Record<string, any>[]>([]);
const updateReports = ref<Report[]>([]);
const selectedRecord = ref<any>(null);
const formattedMemo = ref('');
const windowWidth = ref(window.innerWidth);

const notiList = ref<Notification[]>([]);

const dataSourceInquires = ref<Record<string, any>[]>([]);
const projColumn = getProjColumn(t);
const inquireColumn = getInquireColumn(t);
const {isDischarger } = storeToRefs(authStore);

let LINE_HEIGHT = 16;
const noticeRefs = ref<(HTMLElement | null)[]>([]);
const updateRefs = ref<(HTMLElement | null)[]>([]);

const handleResize = () => {
  windowWidth.value = window.innerWidth;
  if (windowWidth.value < 1800) {
    projColumn[0].width = 100;
  } else projColumn[0].width = 60;
};

onMounted(() => {
  handleResize();
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

watch(windowWidth, (newWidth) => {
  if (newWidth < 1800) {
    projColumn[0].width = 100;
  } else projColumn[0].width = 60;
});

const fetchdata = async () => {
  try {
    // for notice
    notiList.value = (await getNotiForHome()) as Notification[];
    // for update report
    updateReports.value = (await getUpdateReports()) as Report[];
    // for project
    dataSourceProject.value = await getProjects(selectedCompanyId.value);
    // for inquire
    if (authStore.isDischarger) {
      dataSourceInquires.value = await getInquire(Number(selectedCompanyId.value));
    }
    await nextTick();
    checkEllipsis();
  } catch (error) {
    console.error('Error fetching inquiry list:', error);
  }
};
fetchdata();
watch([selectedCompanyId], fetchdata);

const checkEllipsis = () => {
  noticeRefs.value.forEach((span) => addEllipsis(span as HTMLElement));
  updateRefs.value.forEach((span) => addEllipsis(span as HTMLElement));
};

const addEllipsis = (span: HTMLElement) => {
  if (span.offsetHeight > LINE_HEIGHT) {
    span.classList.add('ellipsis');
    span.style.cursor = 'pointer';
  }
};

const displayContentInquire = (inquireId: any) => {
  viewingInquiryId.value = inquireId;
  isInquiryModalVisible.value = true;
};
const openMemoModal = (record: any) => {
  selectedRecord.value = record;
  formattedMemo.value = selectedRecord?.value.memo.replace(/\n/g, '<br/>');
  isMemoModalVisible.value = true;
};

const getClassStatus = (status: string) => {
  switch (status) {
    case 'AWAITING_RESPONSE':
      return 'blue';
    case 'RESPONSE_RECEIVED':
      return 'red';
    default:
      return 'gray';
  }
};

const updateInquire = async () => {
  dataSourceInquires.value = await getInquire(Number(selectedCompanyId.value));
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.status-tag {
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  &.pink-status {
    background-color: pink;
  }

  &.blue-status {
    background-color: $blue-button-color;
  }

  &.red-status {
    background-color: #f67e7e;
  }

  &.gray-status {
    background-color: $gray-button-color;
  }
}

.proj_memo_title {
  text-align: center;
  color: #60a5fa;
  font-size: 20px;
  padding-bottom: 5px;
  border-bottom: 1px solid #817e7e;
}

.card-container > div > .dashboard_gadget:not(:first-child) {
  margin-top: 20px;
}
.custom-modal-header {
  text-align: center !important;
}

.dashboard_gadget {
  width: 100%;
  border: 2px solid #5b9bd5;
  padding: 20px;

  .gadget_left {
    width: 120px;
    display: inline-block;
    vertical-align: top;

    > span:nth-child(1) {
      font-size: 20px;
      display: block;
      font-weight: bold;
      color: $blue-text-color2;
    }

    > span:nth-child(2) {
      margin-top: 10px;
      font-size: 12px;
      font-weight: bold;
      display: block;
    }
  }

  .gadget_right {
    width: calc(100% - 120px);
    display: inline-block;

    > div > div:first-child {
      margin-bottom: 10px;
    }

    > div:not(:last-child) {
      border-bottom: 1px solid #e0e0e0;
      padding-bottom: 5px;
    }

    > div:not(:first-child) {
      margin-top: 10px;
    }

    .notice_update_date {
      display: inline-block;
      width: 85px;
      margin-left: 15px;
    }

    .update_date {
      display: inline-block;
      width: 80px;
      margin-left: 10px;
      vertical-align: top;
      padding-bottom: 2px;
    }

    .notice_subject {
      display: inline-block;
      font-size: 16px;
    }

    .important {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      color: #ffffff;
      text-align: center;
      vertical-align: middle;
      padding-top: 7px;
      display: inline-block;
    }

    .red {
      background-color: $red-button-color;
    }

    .yellow {
      background-color: $yellow-button-color;
    }

    .blue {
      background-color: $blue-button-color;
    }

    .gray {
      background-color: $gray-button-color;
    }

    .update_info {
      display: inline-block;
      width: calc(100% - 90px);
    }

    .status {
      width: 100px;
      color: #ffffff;
      display: inline-block;
      border-radius: 3px;
      height: 25px;
      text-align: center;
      font-size: 12px;
      padding-top: 4px;
    }
  }
}

.card-container > div {
  > div.dashboard_new {
    max-height: 367px;
    min-height: 150px;
    overflow: hidden;
    overflow-y: auto;

    .important {
      margin-top: -5px;
    }
  }

  > div.dashboard_update {
    max-height: 294px;
    min-height: 150px;
    overflow: hidden;
    overflow-y: auto;

    .gadget_right {
      > div:not(:first-child) > div {
        margin-top: 20px;
      }
    }
  }

  > div.dashboard_inquire {
    .important {
      padding-top: 4px;
    }
  }
}

.ellipsis {
  white-space: pre-line;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.normal-text {
  word-wrap: break-word;
  white-space: pre-line;
  cursor: pointer;
}

.no-ellipsis {
  cursor: default;
}

img {
  display: initial;
}

.memo-content {
  height: 200px;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 4px;
  width: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background-color: #e1e6e6;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  border-radius: 6px;
  background-color: gray;
}

:deep(.dashboard_project th),
:deep(.dashboard_inquire th){
  text-align: center !important;
}
</style>
